module.exports = __webpack_public_path__ + "img/gs.49fa4d63.svg";